import {label} from "yarn/lib/cli";

<template>
  <div v-if="!loading && refundOfflineApply.id">
    <div class="container">
      <div
        v-if="refundOfflineApply.account_nonuniqueness_explain"
        class="line"
      >
        <span>账户唯一性验证失败说明: {{ refundOfflineApply.account_nonuniqueness_explain }}</span>
      </div>
      <div class="line">
        <span>其他说明: {{ refundOfflineApply.other_explain || "无" }}</span>
      </div>
      <div class="line">
        <span>验证及相关说明: {{ refundOfflineApply.error_msg || "无" }}</span>
      </div>
      <div class="hr" />
      <div v-if="refundOfflineApply.bfiles.length">
        <div class="line">
          <span>附件:</span>
          <Attachments :files="refundOfflineApply.bfiles" />
        </div>
      </div>
      <div
        v-else
        class="line"
      >
        <Alert type="warning">
          <Icon type="ios-paper-outline" />
          没有添加附件
        </Alert>
      </div>
      <div v-if="refundOfflineApply.user_flow">
        <div class="line">
          <UserFlow :user_flow="refundOfflineApply.user_flow" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserFlow from "@/views/components/flow/user_flow.vue";
import Attachments from "@/views/components/file/attachments.vue";
import { getRefundOfflineApplyDetailApi } from "./services";


export default {
  name: 'RefundOfflineApplyExpand',
  components: {
    Attachments,
    UserFlow
  },
  props: {
    model_id: {
      type: Number,
      required: true,
    },
    // 可选：展示操作区
    showActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      error: null,
      refundOfflineApply: null,
      reqSeq: 0, // 并发序号，避免旧请求覆盖新数据
    };
  },
  created() {
    this.fetchDetail();
  },
  methods: {
    async fetchDetail() {
      const seq = ++this.reqSeq;
      this.loading = true;
      this.error = null;
      try {
        console.log('getRefundOfflineApplyDetailApi', this.model_id)
        // 假设详情接口以 id 作为查询参数
        const res = await getRefundOfflineApplyDetailApi({ id: this.model_id });
        // 若期间又触发了新的请求，忽略本次结果
        if (seq !== this.reqSeq) return;
        // res 数据结构按后端返回放置，这里直接使用
        this.refundOfflineApply = res || {};
      } catch (e) {
        if (seq !== this.reqSeq) return;
        this.error = e && (e.message || "加载失败");
        this.refundOfflineApply = null;
      } finally {
        if (seq === this.reqSeq) {
          this.loading = false;
        }
      }
    },
    refresh() {
      this.fetchDetail();
      this.$emit("on-refresh", this.model_id);
    }

  },
}
</script>

<style scoped>

</style>